import PrimaryButton from '../PrimaryButton';
import DialogActions from '@material-ui/core/DialogActions';
import { Typography } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { globalStyles as styles } from '../style/gstheme';

class MarketplaceProcessingDialog extends React.Component {

    render() {

        const { classes, status, complete, onGoToProject } = this.props;

        return (
            <Dialog
                data-test="market-place-processing-dialog"
                fullWidth
                open={true} onClose={this.exitMarketplace} aria-labelledby="marketplace-dialog-title">
                <DialogTitle disableTypography className={classes.mainHeading} id="marketplace-dialog-title">Processing Your Example</DialogTitle>
                <DialogContent>
                    <Typography data-test="example-status" variant="body2">{status}</Typography>
                </DialogContent>
                <DialogActions className={classes.dialogActions}>
                    <PrimaryButton dataTest="go-to-project" disabled={!complete} onClick={onGoToProject}>Go to Project</PrimaryButton>
                </DialogActions>

            </Dialog>
        );
    }
}

MarketplaceProcessingDialog.propTypes = {
    classes: PropTypes.object,
    complete: PropTypes.bool.isRequired,
    status: PropTypes.string.isRequired,
    onGoToProject: PropTypes.func.isRequired
};

export default withStyles(styles)(MarketplaceProcessingDialog);